module.exports = __webpack_public_path__ + "img/128-eb7a2e.png";